import { jsxs, jsx } from "react/jsx-runtime";
const WorkspaceNotFoundIcon = () => /* @__PURE__ */ jsxs("svg", { width: "200", height: "180", viewBox: "0 0 200 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M189.611 163.881L184.918 166.612C186.276 165.82 187.121 164.141 187.128 161.749L191.821 159.018C191.814 161.41 190.975 163.088 189.611 163.881Z",
      fill: "#D2D2D2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M187.307 99.41L187.127 161.749C187.114 166.566 183.712 168.504 179.525 166.086L76.6294 106.625C72.4491 104.206 69.0609 98.3442 69.0743 93.5345L69.254 31.1952L187.307 99.41Z",
      fill: "#F4F4F4"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M187.309 99.4101L192.001 96.6788L191.822 159.018L187.129 161.743L187.309 99.4101Z", fill: "#D2D2D2" }),
  /* @__PURE__ */ jsx("path", { d: "M69.2539 31.1953L73.9467 28.4707L191.999 96.6789L187.307 99.4101L69.2539 31.1953Z", fill: "#D2D2D2" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M71.4648 11.2438L76.1577 8.51249C77.5356 7.7131 79.446 7.81969 81.5494 9.03876L76.8566 11.77C74.7531 10.5576 72.8427 10.4444 71.4648 11.2438Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M187.306 84.3216L191.998 81.5903L191.952 96.4324L187.266 99.157L187.306 84.3216Z", fill: "#AAAAAA" }),
  /* @__PURE__ */ jsx("path", { d: "M76.8555 11.7758L81.5483 9.04456L184.444 68.4994L179.751 71.2306L76.8555 11.7758Z", fill: "#AAAAAA" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M179.751 71.2315C183.938 73.6497 187.32 79.5119 187.306 84.3216L187.266 99.157L69.207 30.9488L69.247 16.1134C69.2603 11.3037 72.6684 9.35854 76.8487 11.7767L179.751 71.2315Z",
      fill: "url(#paint0_linear)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M179.75 71.2315L184.443 68.5002C188.63 70.9184 192.011 76.7806 191.998 81.5903L187.305 84.3216C187.318 79.5119 183.937 73.6497 179.75 71.2315Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M176.706 106.424L117.268 71.6573C117.207 71.6123 117.135 71.5846 117.06 71.5771C116.985 71.5696 116.909 71.5826 116.84 71.6147L115.355 72.4884C115.424 72.4566 115.5 72.4439 115.575 72.4516C115.651 72.4593 115.723 72.4871 115.783 72.5322L175.222 107.3C175.396 107.416 175.541 107.57 175.645 107.752C175.749 107.934 175.809 108.137 175.82 108.347L175.788 119.612C175.795 119.686 175.783 119.761 175.752 119.83C175.722 119.898 175.674 119.957 175.613 120.001L177.098 119.128C177.159 119.084 177.207 119.025 177.238 118.956C177.268 118.888 177.28 118.813 177.273 118.738L177.304 107.472C177.294 107.262 177.234 107.059 177.13 106.877C177.026 106.695 176.881 106.54 176.706 106.424Z",
      fill: "#D2D2D2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M175.534 128.634L116.096 93.8678C116.035 93.8224 115.964 93.7943 115.888 93.7866C115.813 93.7789 115.737 93.7918 115.668 93.824L114.184 94.6989C114.252 94.6668 114.328 94.6538 114.403 94.6613C114.479 94.6688 114.551 94.6965 114.612 94.7415L174.05 129.508C174.224 129.624 174.369 129.778 174.473 129.96C174.577 130.142 174.637 130.346 174.648 130.555L174.616 141.82C174.624 141.895 174.611 141.97 174.58 142.038C174.55 142.107 174.502 142.166 174.441 142.21L175.926 141.336C175.987 141.292 176.035 141.233 176.066 141.165C176.097 141.096 176.109 141.021 176.101 140.946L176.132 129.681C176.121 129.472 176.062 129.268 175.958 129.087C175.854 128.905 175.709 128.75 175.534 128.634Z",
      fill: "#D2D2D2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M108.513 67.1271L49.0754 32.3592C49.0149 32.3144 48.9435 32.2866 48.8686 32.2789C48.7938 32.2712 48.7182 32.2838 48.6499 32.3154L47.1641 33.1903C47.2322 33.1582 47.3078 33.1451 47.3827 33.1526C47.4577 33.1601 47.5292 33.1879 47.5896 33.2329L107.031 68.002C107.206 68.117 107.35 68.2715 107.453 68.4529C107.557 68.6343 107.616 68.8375 107.626 69.0461L107.596 80.3125C107.603 80.3874 107.591 80.4629 107.56 80.5314C107.529 80.6 107.48 80.6592 107.419 80.7031L108.905 79.8294C108.966 79.7852 109.014 79.7257 109.045 79.657C109.076 79.5882 109.088 79.5125 109.08 79.4376L109.112 68.1724C109.102 67.9633 109.042 67.7595 108.938 67.5779C108.834 67.3962 108.689 67.2417 108.513 67.1271Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M107.032 68.0021C107.206 68.1175 107.351 68.2721 107.454 68.4534C107.558 68.6346 107.617 68.8376 107.628 69.0461L107.597 80.3125C107.597 80.697 107.328 80.8552 106.997 80.6605L47.5555 45.8926C47.3815 45.7766 47.237 45.6215 47.1338 45.4395C47.0305 45.2576 46.9713 45.0539 46.9609 44.8449L46.9926 33.5797C46.9926 33.194 47.26 33.0394 47.5908 33.2329L107.032 68.0021Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M174.046 129.508C174.221 129.624 174.366 129.778 174.47 129.96C174.574 130.142 174.634 130.345 174.645 130.555L174.613 141.821C174.613 142.205 174.342 142.361 174.005 142.168L114.566 107.401C114.391 107.285 114.246 107.13 114.142 106.948C114.039 106.766 113.979 106.562 113.969 106.352L113.999 95.0857C113.999 94.7012 114.27 94.5479 114.607 94.7414L174.046 129.508Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M175.427 107.3C175.602 107.416 175.747 107.57 175.851 107.752C175.954 107.934 176.014 108.138 176.025 108.347L175.994 119.612C175.994 119.998 175.722 120.153 175.386 119.96L115.952 85.1919C115.778 85.076 115.633 84.9205 115.529 84.7381C115.425 84.5557 115.366 84.3515 115.355 84.1418L115.386 72.8766C115.386 72.4909 115.657 72.3388 115.994 72.5322L175.427 107.3Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M71.1852 117.343C58.4185 109.875 37.79 109.875 25.1035 117.343C18.8065 121.05 15.6525 125.903 15.6367 130.766L15.6732 118.048C15.689 113.181 18.843 108.333 25.14 104.626C37.8216 97.1581 58.4465 97.1581 71.2217 104.626C77.6427 108.38 80.8539 113.316 80.8381 118.237L80.8016 130.954C80.8162 126.033 77.6136 121.103 71.1852 117.343Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: "0.4",
      d: "M71.109 108.384C58.3423 100.918 37.7137 100.918 25.0273 108.384C12.3408 115.851 12.4126 127.958 25.1829 135.425C37.9532 142.893 58.5769 142.892 71.2536 135.425C83.9304 127.959 83.8732 115.852 71.109 108.384Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.7041 101.467C35.3889 92.2373 60.8882 92.2373 76.6715 101.467C92.4548 110.696 92.5326 125.662 76.8527 134.897C61.1728 144.133 35.6685 144.127 19.8901 134.897C4.1117 125.668 4.02416 110.696 19.7041 101.467ZM71.2001 104.631C58.4334 97.1642 37.8061 97.1642 25.1245 104.631C12.4429 112.097 12.5098 124.204 25.2789 131.67C38.048 139.137 58.6741 139.138 71.3496 131.67C84.0251 124.203 83.9643 112.103 71.2001 104.635V104.631Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M19.9277 147.421C11.9844 142.778 8.0194 136.68 8.0352 130.587L8.07168 117.871C8.05588 123.955 12.0196 130.055 19.9642 134.704C35.7426 143.933 61.2504 143.933 76.9255 134.704C84.7144 130.118 88.6162 124.118 88.632 118.105L88.5955 130.824C88.5809 136.837 84.6779 142.835 76.889 147.421C61.2091 156.65 35.7061 156.65 19.9277 147.421Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M90.7882 144.681C90.7381 145.682 90.4533 146.658 89.9567 147.529C89.4602 148.4 88.7658 149.142 87.9297 149.695C87.641 149.906 87.3007 150.036 86.9446 150.07C86.5886 150.104 86.2299 150.041 85.9065 149.889L76.3777 144.314C76.086 144.1 75.8558 143.812 75.7101 143.481C75.5643 143.149 75.5082 142.785 75.5472 142.425C75.5975 141.423 75.8826 140.447 76.3794 139.576C76.8761 138.705 77.5707 137.963 78.407 137.41C78.6945 137.198 79.0341 137.069 79.3894 137.035C79.7448 137 80.1028 137.063 80.4253 137.217L89.9541 142.791C90.2465 143.005 90.4774 143.292 90.6238 143.624C90.7702 143.956 90.8269 144.32 90.7882 144.681Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M90.4597 140.916L123.033 159.965L116.499 171.433L83.9256 152.383C83.4539 152.039 83.0808 151.577 82.8433 151.043C82.6058 150.509 82.5124 149.922 82.5723 149.341C82.6541 147.721 83.1148 146.144 83.9173 144.735C84.7198 143.326 85.8417 142.125 87.1926 141.23C87.6575 140.886 88.2071 140.675 88.7826 140.619C89.3582 140.564 89.9379 140.667 90.4597 140.916Z",
      fill: "#D2D2D2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M124.385 163.014C124.385 160.023 122.318 158.794 119.765 160.279C118.413 161.174 117.291 162.374 116.488 163.783C115.685 165.192 115.225 166.77 115.145 168.39C115.145 171.386 117.212 172.615 119.765 171.129C121.116 170.232 122.237 169.031 123.04 167.622C123.842 166.212 124.303 164.634 124.385 163.014Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: "paint0_linear", x1: "128.257", y1: "10.7372", x2: "128.257", y2: "99.157", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { offset: "0.177741", stopColor: "#F4F4F4" }),
    /* @__PURE__ */ jsx("stop", { offset: "0.631431", stopColor: "#DCDCDC" })
  ] }) })
] });
export {
  WorkspaceNotFoundIcon
};
//# sourceMappingURL=WorkspaceNotFoundIcon.js.map
